'use strict';
var angular:angular.IAngularStatic =  require('angular');
const forEach = require('lodash/forEach');
const _get = require('lodash/get');
import { Injectable} from 'ng-metadata/core';

    @Injectable()
    export class SearchResultParser{

        /* private members */
        constructor() {
        }

        parseImagesSearchResponse(response) {
            let docs = response.docs;

            let arrayLength = docs.length;
            let images = [];
            for (let i = 0; i < arrayLength; i++) {
                let item = docs[i];
                this.enrichItem(item);
                images.push(item.thumbnail);
            }

            return {
                images: images

            };

        }

        

        parseSearchResponse(response){
            let docs = response.docs;
            let info = response.info;
            let didUMean= response.did_u_mean;
            let expandedSearchAfterZeroResults = response.expandedSearchAfterZeroResults;


            let facetsList;

            try {
                facetsList = _get(response, 'facets', []);
            } catch (e) {
                facetsList = [];
            }

            facetsList.forEach(
                function(e) {
                    e.count = e.values.length;
                    /* hack for MetaLib */
                    if (response.searchStatus && e.name === 'domain') {
                        e.values.forEach((value) => {
                            let curSearchStatus = response.searchStatus.filter((e)=> {return e['full-name'] === value.value;});
                            if (curSearchStatus && curSearchStatus.length>0) {
                                value.maxCount = curSearchStatus[0].total;
                             }
                        });
                    }
                    
                }
            );
            
            let arrayLength = docs? docs.length : 0;
            let groups = [];
            for (let i = 0; i < arrayLength; i++) {
                let item = docs[i];
                this.enrichItem(item);
                groups.push(item);
            }

            return {
                lang3: response.lang3,
                featuredResult:response.featuredResultJson,
                did_u_mean: didUMean,
                groups: groups,
                info: info,
                facetsList: facetsList,
                beaconO22: response.beaconO22,
                expandedSearchAfterZeroResults: expandedSearchAfterZeroResults
            };
        }

        private removeLinksPrefix(link) {
            if(!link){
                link = "";
            }
            return link.replace('http://purl.org/pnx/linkType/', '');
        }

        private removePrefixFromLinks(item) {

            let links;

            if(item.delivery && item.delivery.link) {
                links = item.delivery.link;
            }

            item.link = {};
            if (angular.isDefined(links)) {
                for (let i = 0; i < links.length; i++) {
                    item.link[this.removeLinksPrefix(links[i].linkType)] = this.removeLinksPrefix(links[i].linkURL);
                }
            }

        }

        private enrichItem(item) {
            this.removePrefixFromLinks(item);
        }


    }













// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResultParser.service.ts